



























import { defineComponent } from '@vue/composition-api';
import { useStore } from '@/utils/use-store';

export default defineComponent({
  setup(props, context) {
    const store = useStore();
    const { user } = store.state;

    /**
     * Handler for log out event
     * */
    async function logOut() {
      try {
        await store.dispatch('logout', user.id);
      } catch (e) {
        const message: string = e.response ? e.response.data.message || e.response.data.error : e.message;
        throw Error(message);
      }
    }

    return {
      user,
      logOut
    };
  }
});
